export default __webpack_public_path__ + "static/media/antecna.a3e4e3b7.png";